export const generateTestId = (value: string) => ({
  'data-test': value,
});
